import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { LoadingButton } from '@mui/lab';
import { Avatar, Button, Paper, Stack, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import FolderIcon from "@mui/icons-material/Folder";
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import * as XLSX from 'xlsx';
import { Download } from '@mui/icons-material';

const Bulkagrdisc = () => {
  const [disbleButton, setDisbleButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  // const [Headdata, setHeadData] = useState(null);
  const apiRef = useRef();

  const swal = useSwalWrapper()
  const fetchLotDetail = useCallback(async () => {
    data && setData(null)
    setDisbleButton(true)
    await jwtAuthAxios.get('/bulk/getbulkrate').then(async res => {
      setData(res.data);
      setDisbleButton(false)
    }).catch(r => swal.fire({
      icon: 'error',
      text: r,
    }))
  },[])
  useEffect(fetchLotDetail, [])
  const columns = [
    { field: "FL_SUB_LOT", flex: 1, headerName: "Lot Code" },
    { field: "FL_ASK_RATE", flex: 1, headerName: "ASK. Rate", type: 'text'   },
    { field: "FL_GREEN_RATE", flex: 1, headerName: "Green Rate", type: 'text'  },
    { field: "FL_RED_RATE", flex: 1, headerName: "Red Rate", type: 'text'  },
  ];
  const getFieldName = (key) => {
    switch (key) {
      case 'Lot no.':
        return 'FL_SUB_LOT'
        break;
      case 'Ask Rate ($)':
        return 'FL_ASK_RATE'
        break;
      case 'Green Rate ($)':
        return 'FL_GREEN_RATE'
        break;
      case 'Red Rate ($)':
        return 'FL_RED_RATE'
        break;
      default:
        return key
        break;
    }
  }
  const handleButtonClick = async (props) => {
    // Get all promises for updating rows
    // if(props.id > 10000 && props.row.P_CODE != null){
    //   alert('field is not editable')
    //   setData(data);
    //   setDisbleButton(false)
    //   return
    // }
    setTimeout(async () => {
      // console.log( );
      // if( (props.id > 10000 || props.row.P_CODE) && (props.field != 'SHORT' && props.field != 'ANAME' && props.field != 'ACH_NAME')) {
      const updatedCellValue = await apiRef.current.getCellValue(props.id, props.field);
      const updatedRows = await Promise.all(
        data.map(async (row) => {
          // console.log(row.FL_ID, props.id);
          if (row.FL_ID == props.id) {
            return { ...row, [props.field]: updatedCellValue, Edited: true };
          }
          return row;
        })
      );
      // console.log(updatedRows);
      setData(updatedRows);
      setDisbleButton(false)
      // }
    }, 100);
    // Update the state or perform other operations with updatedRows
  };
  const saveDataHandler = async () => {
    setLoading(false)
    // console.log(data);
    let FrmData = await data.filter(s=> s.Edited == true)
    await jwtAuthAxios.post('/bulk/getbulkrate',{"bulkRate":FrmData}).then(res=>{
      swal.fire({
        icon: 'success',
        text: res.data.message,
      });
      fetchLotDetail()
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: e,
      });    
      }).finally(e=>{
        setLoading(false)
      });
  }
  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };
  const downloadExcel = () => {
  // const { data, fileName } = this.state;
const DData = data.map(d=> ({[`Lot no.`]:d.FL_SUB_LOT,[`Ask Rate ($)`]:d.FL_ASK_RATE,[`Green Rate ($)`]:d.FL_GREEN_RATE,[`Red Rate ($)`]:d.FL_RED_RATE})) 	

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(DData);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  XLSX.writeFile(workbook, 'BULK_RATE.xlsx');
};


  const handleFileInputChange = (event) => {
    const files = event.target.files;
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const UNITdata = new Uint8Array(e.target.result);
      const workbook = XLSX.read(UNITdata, { type: 'array' });

      // Assuming the first sheet is the one you want to convert
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the worksheet to JSON format
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      // const result = 

      const REOBJ = jsonData.slice(1).map((row,i) => {
        const obj = {};
        jsonData[0].forEach((key, index) => {
          obj[`${getFieldName(key.trim())}`] = row[index];
        });
        // console.log(obj);
        return { ...obj, Edited: true, FL_ID: `new-${jsonData.length}-${i}` };
      });
      setData(REOBJ)
    };
    
    reader.readAsArrayBuffer(file);
    // console.log(files);
    // Handle the file upload logic here...
  };
  // useEffect(()=>{
  //   console.log(data?.map(row=> row.LID) );
  // },[data])

  return (
    <JumboCardQuick action={<Stack direction={"row"} justifyContent={'end'} spacing={2}>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileInputChange}
      />
      <Tooltip title="DownLoad Lot Data"><Avatar onClick={downloadExcel}><Download /></Avatar></Tooltip>
      <Tooltip title="Upload Data"><Avatar onClick={handleUploadClick}><FolderIcon /></Avatar></Tooltip>
      <LoadingButton disabled={disbleButton} loading={loading} variant='contained' onClick={saveDataHandler}>Save</LoadingButton></Stack>} sx={{ p: 0 }} title={'Packet Price Bind'} >

      <Paper elevation={0} sx={({ backgroundColor: theme => theme.palette.action.hover, p: 0 })}>
        {!Boolean(data) ? <TableSkeleton /> : <DataGrid
          rows={data || []}
          columns={columns}
          pageSize={5}
          apiRef={apiRef}
          density='compact'
          getRowId={(row) => row.FL_ID}
          rowsPerPageOptions={[50, 100, 200]}
          sx={{ p: 0, fontSize: '16px' }}
          onCellEditStart={(pams) => setDisbleButton(true)}
          onCellEditStop={handleButtonClick}
          disableRowSelectionOnClick
        />}
      </Paper>
    </JumboCardQuick>
  )
};
Bulkagrdisc.Modulename = 'Bulkagrdisc';

export default Bulkagrdisc;

